import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../../ui-kit/confirmation-dialog/confirmation-dialog.component';
import { AllocationViewProfile } from '../allocation-view-profiles/models/allocation-view-profile.model';
import { AllocationViewMode } from './constants';

export class AllocationViewSelectSavedViewMode {
  public static readonly type = '[AllocationView] Select Saved View Mode';
}

export class AllocationViewSetViewMode {
  public static readonly type = '[AllocationView] Set View Mode';

  constructor(public viewMode: AllocationViewMode) {}
}

export class AllocationViewSetLastSelectedUli {
  public static readonly type = '[AllocationView] Set Last Selected Uli';

  constructor(public uli: string) {}
}

export class AllocationViewSetProfile {
  public static readonly type = '[AllocationView] Set Profile';

  constructor(public profile: AllocationViewProfile) {}
}

export class AllocationViewSetLastChangedUli {
  public static readonly type = '[AllocationView] Set Last Changed Uli';

  constructor(public uli: string) {}
}

export class AllocationViewSetLastSelectedUliToChanged {
  public static readonly type = '[AllocationView] Set Last Selected Uli To Changed';
}

export class AllocationViewSetLastChangedUliAsHighlighted {
  public static readonly type = '[AllocationView] Set Last Changed Uli As Highlighted';
}

export class AllocationViewSetHighlightedUli {
  public static readonly type = '[AllocationView] Set Highlighted Uli';

  constructor(public uli: string) {}
}

export class AllocationViewClearHighlightedUli {
  public static readonly type = '[AllocationView] Clear Highlighted Uli';
}

export class AllocationViewSetHighlightedSlot {
  public static readonly type = '[AllocationView] Set Highlighted Slot';

  constructor(public payload: { slotId: number; dialog?: MatDialogRef<ConfirmationDialogComponent> }) {}
}

export class AllocationViewSetFixedTimelineValue {
  public static readonly type = '[AllocationView] Set Fixed Timeline Value';

  constructor(public payload: boolean | undefined) {}
}

export class AllocationViewClearLastChangedUli {
  public static readonly type = '[AllocationView] Clear Last Changed Uli';
}

export class AllocationViewTriggerRefresh {
  public static readonly type = '[AllocationView] Trigger Refresh';

  constructor(public payload: boolean) {}
}
export class AllocationViewSetCalendarEdit {
  public static readonly type = '[AllocationView] Set Calendar Edit';

  constructor(public payload: boolean) {}
}

export class AllocationViewInitialState {
  public static readonly type = '[AllocationView] Set Initial State';
}
